import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-vehicle-not-found',
  templateUrl: './vehicle-not-found.component.html',
  styleUrls: ['./vehicle-not-found.component.scss']
})
export class VehicleNotFoundComponent implements OnInit {

  @Input() routerLink;
  @Input() show;

  constructor() { }

  ngOnInit() {
  }

}
